import React from 'react';
import {
  Box,
  Container,
  SimpleGrid,
  Stack,
  Text,
  Flex,
  Heading,
  Link,
  HStack,
} from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { FooterLogo } from './SpeedcodeLogo';

export default function Footer() {
  return (
    <Box 
      bgGradient="linear(to-b, gray.900, gray.800)"
      color="gray.200" 
      mt="auto"
      position="relative"
      overflow="hidden"
      _before={{
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'radial-gradient(circle at 30% 20%, rgba(0, 102, 204, 0.15) 0%, transparent 50%), radial-gradient(circle at 70% 80%, rgba(124, 58, 237, 0.15) 0%, transparent 50%)',
        pointerEvents: 'none',
      }}
    >
              <Container maxW="container.xl" py={12} position="relative" zIndex={1}>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={8}>
          {/* Brand Section */}
          <Stack spacing={4}>
            <HStack spacing={3}>
              <FooterLogo />
              <Heading size="md" color="white">
                Speedcode
              </Heading>
            </HStack>
            <Text fontSize="sm" color="gray.300" lineHeight="1.6">
              Master performance engineering through hands-on challenges and real-world parallel programming problems.
            </Text>
          </Stack>

          {/* Platform Links */}
          <Stack spacing={4}>
            <Heading size="sm" color="white">
              Platform
            </Heading>
            <Stack spacing={2}>
              <Link href="/" color="gray.300" _hover={{ color: 'white', textDecoration: 'none' }} fontWeight="500">
                Problems
              </Link>
              <Link href="/leaderboard" color="gray.300" _hover={{ color: 'white', textDecoration: 'none' }} fontWeight="500">
                Leaderboard
              </Link>
              <Link href="/competitions" color="gray.300" _hover={{ color: 'white', textDecoration: 'none' }} fontWeight="500">
                Competitions
              </Link>
            </Stack>
          </Stack>

          {/* Resources */}
          <Stack spacing={4}>
            <Heading size="sm" color="white">
              Resources
            </Heading>
            <Stack spacing={2}>
              <Link 
                href="https://github.com/OpenCilk/opencilk-project" 
                target="_blank" 
                rel="noopener noreferrer"
                color="gray.300" 
                _hover={{ color: 'white', textDecoration: 'none' }}
                display="flex"
                alignItems="center"
                fontWeight="500"
              >
                OpenCilk Project
                <ExternalLinkIcon ml={1} />
              </Link>
              <Link 
                href="https://opencilk.org" 
                target="_blank" 
                rel="noopener noreferrer"
                color="gray.300" 
                _hover={{ color: 'white', textDecoration: 'none' }}
                display="flex"
                alignItems="center"
                fontWeight="500"
              >
                OpenCilk Documentation
                <ExternalLinkIcon ml={1} />
              </Link>
              <Link href="/api-docs" color="gray.300" _hover={{ color: 'white', textDecoration: 'none' }} fontWeight="500">
                API Documentation
              </Link>
            </Stack>
          </Stack>

          {/* Connect */}
          <Stack spacing={4}>
            <Heading size="sm" color="white">
              Connect
            </Heading>
            <Stack spacing={2}>
              <Link 
                href="https://github.com/SpeedCodeOrg" 
                target="_blank" 
                rel="noopener noreferrer"
                color="gray.300" 
                _hover={{ color: 'white', textDecoration: 'none' }}
                display="flex"
                alignItems="center"
                fontWeight="500"
              >
                GitHub
                <ExternalLinkIcon ml={1} />
              </Link>
              <Link 
                href="mailto:contact@speedcode.org" 
                color="gray.300" 
                _hover={{ color: 'white', textDecoration: 'none' }}
                fontWeight="500"
              >
                Contact
              </Link>
              <Link href="/privacy" color="gray.300" _hover={{ color: 'white', textDecoration: 'none' }} fontWeight="500">
                Privacy Policy
              </Link>
            </Stack>
          </Stack>
        </SimpleGrid>

        {/* Bottom Section */}
        <Box borderTop="1px solid" borderColor="gray.700" mt={8} pt={8}>
          <Flex 
            direction={{ base: 'column', md: 'row' }} 
            justify="space-between" 
            align={{ base: 'flex-start', md: 'center' }}
            gap={4}
          >
            <Text fontSize="sm" color="gray.400" fontWeight="500">
              &copy; 2024 Speedcode. All rights reserved.
            </Text>
            <Text fontSize="sm" color="gray.400" mt={{ base: 2, md: 0 }} fontWeight="500">
              Built with ❤️ for the performance engineering community
            </Text>
          </Flex>
        </Box>
      </Container>
    </Box>
  );
} 